import { Injectable, inject } from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {of} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class EducationalMaterialsUserGuard {
    canActivate() {
        return of(true);
    }
}

export const isEducationalMaterialsUser: CanActivateFn = () =>
    inject(EducationalMaterialsUserGuard).canActivate();
